import { forwardRef } from 'react';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
var Connector = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var path = _ref.path,
      gradient = _ref.gradient,
      gradientDots = _ref.gradientDots,
      _ref$gradientRotation = _ref.gradientRotation,
      gradientRotation = _ref$gradientRotation === void 0 ? 0 : _ref$gradientRotation,
      width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      id = _ref.id;
  return _jsxs("svg", {
    width: width,
    height: height,
    viewBox: "0 0 ".concat(width, " ").concat(height),
    ref: ref,
    className: className,
    fill: "none",
    children: [gradient && _jsx("path", {
      strokeLinejoin: "round",
      d: path,
      stroke: typeof gradient === "string" ? gradient : "url(#paint".concat(id, "_linear_lined)"),
      strokeWidth: "16"
    }), gradientDots && _jsx("path", {
      d: path,
      stroke: typeof gradientDots === "string" ? gradientDots : "url(#paint".concat(id, "_linear_lined_dots)"),
      strokeWidth: "4",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "0.1 16"
    }), (typeof gradient === "object" || typeof gradientDots === "object") && _jsxs("defs", {
      children: [typeof gradient === "object" && _jsx("linearGradient", {
        x1: 0,
        y1: 0,
        x2: width > height ? width : height,
        y2: 0,
        id: "paint".concat(id, "_linear_lined"),
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "rotate(".concat(gradientRotation, ")"),
        children: gradient
      }), typeof gradientDots === "object" && _jsx("linearGradient", {
        x1: 0,
        y1: 0,
        x2: width > height ? width : height,
        y2: 0,
        id: "paint".concat(id, "_linear_lined_dots"),
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "rotate(".concat(gradientRotation, ")"),
        children: gradientDots
      })]
    })]
  });
});
export default Connector;